import { Route, Routes } from 'react-router-dom'
import MarketingPage from './pages/marketing-page/MarketingPage'
import QuotePage from './pages/quote-page/QuotePage'
import NotFoundPage from './pages/not-found-page/NotFoundPage'

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<MarketingPage />} />
    <Route path="/:token" element={<QuotePage />} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
)

export default AppRoutes
